export default (pageName) => {
    console.log('===> setCurrentPage', pageName);
};
